// JED-1020: a rubric bar is a share of the marks given on one criterion, so 100% can be a
// single marked submission. The hover text says how many marks the bar stands for.

// Mirrors the backend's RubricLevelTier, which decides which band each mark counts in,
// so the legend and the hover text name the levels the counts actually cover.
const bandBounds = (n) => {
  if (n === 3 || n === 4) return [1, 2];
  if (n === 5) return [1, 3];
  if (n === 6) return [2, 4];
  if (n === 7) return [2, 5];
  if (n >= 8) {
    const base = Math.floor(n / 3);
    return [base, base + base + (n % 3)];
  }
  return [1, n];
};

export function rubricLegendBands(legends) {
  const levels = Array.isArray(legends) ? legends : [];
  const [topEnd, middleEnd] = bandBounds(levels.length);
  return {
    high: levels.slice(0, topEnd),
    middle: levels.slice(topEnd, middleEnd),
    low: levels.slice(middleEnd),
  };
}

const BAND_NAMES = {
  high: 'Top band',
  middle: 'Middle band',
  low: 'Bottom band',
};

const plural = (n, word) => `${word}${n === 1 ? '' : 's'}`;

const roundPct = (pct) => Math.round(Number(pct) || 0);

export function describeRubricShare({ label, count, marks, submissions, pct }) {
  const share = `${roundPct(pct)}%`;
  if (marks === submissions) {
    return `${label}: ${count} of ${marks} marked ${plural(
      marks,
      'submission'
    )} (${share})`;
  }
  // Several questions on one task can use the same rubric, so a submission is marked more than once.
  return `${label}: ${count} of ${marks} ${plural(
    marks,
    'mark'
  )} across ${submissions} ${plural(submissions, 'submission')} (${share})`;
}

// Null when the backend predates the counts, so a bar never claims "0 submissions".
export function rubricShareCounts(criteria) {
  const counts = criteria && criteria.studentShareCounts;
  if (!counts) return null;
  return {
    high: Number(counts.top) || 0,
    middle: Number(counts.middle) || 0,
    low: Number(counts.bottom) || 0,
    submissions: Number(criteria.submissionCount) || 0,
  };
}

export function buildRubricBarTooltip({ band, grades, pct, counts }) {
  const label = grades && grades.length ? grades.join(', ') : BAND_NAMES[band];
  if (!counts) return `${label}: ${roundPct(pct)}%`;
  const marks = counts.high + counts.middle + counts.low;
  // The backend rounds the middle band to make the three add up to 100, so with small counts
  // its percentage can be one off the count; the hover text works it out from the count.
  return describeRubricShare({
    label,
    count: counts[band],
    marks,
    submissions: counts.submissions,
    pct: marks ? (counts[band] / marks) * 100 : 0,
  });
}
